import React, {useEffect, useState} from 'react';
import {getFallbackAssetImage, IndustryType} from "../../hooks/useIndustryType";
import {appendImageFallbackParam} from "../../utils/appendImageFallbackParam";

interface Props {
    src?: string | null,
    /** Shown when `src` fails to load (e.g. the product image behind a broken node image). */
    fallbackSrc?: string | null,
    style?: React.CSSProperties,
    /** Industry type of the asset's owning client — selects the placeholder image. */
    industryType?: IndustryType | null,
}

const AssetProductImage = ({src, fallbackSrc, style, industryType}: Props) => {
    const [primaryFailed, setPrimaryFailed] = useState(false);
    const [fallbackFailed, setFallbackFailed] = useState(false);

    // A new source gets a fresh chance (e.g. after the node image was replaced).
    useEffect(() => {
        setPrimaryFailed(false);
        setFallbackFailed(false);
    }, [src, fallbackSrc]);

    const fallbackImg = getFallbackAssetImage(industryType);
    const candidate = !primaryFailed && src
        ? src
        : !fallbackFailed && fallbackSrc
            ? fallbackSrc
            : null;
    const resolved = candidate ? appendImageFallbackParam(candidate, industryType) : fallbackImg;

    const handleError = () => {
        if (candidate === src && !primaryFailed) {
            setPrimaryFailed(true);
        } else {
            setFallbackFailed(true);
        }
    };

    return (
        <img
            src={resolved}
            alt="Product"
            onError={handleError}
            style={{
                width: 200,
                height: 200,
                objectFit: "contain",
                borderRadius: 8,
                display: "block",
                ...style,
            }}
        />
    );
}

export default AssetProductImage;
